export const CHILDREN_NUMBER = [
    '첫째아이',
    '둘째아이',
    '셋째아이',
    '넷째아이',
    '다섯째아이',
    '여섯째아이',
    '일곱째아이',
    '여덟째아이',
    '아홉째아이',
    '열째아이',
    '열하나째아이',
    '열둘째아이',
    '열셋째아이',
    '열넷째아이',
    '열다섯째아이',
    '열여섯째아이',
    '열일곱째아이',
    '열여덟째아이',
    '열아홉째아이',
    '스물째아이',
    '스물하나째아이',
    '스물둘째아이',
    '스물셋째아이',
    '스물넷째아이',
    '스물다섯째아이',
    '스물여섯째아이',
    '스물일곱째아이',
    '스물여덟째아이',
    '스물아홉째아이',
    '서른째아이',
    '서른하나째아이',
    '서른둘째아이',
    '서른셋째아이',
    '서른넷째아이',
    '서른다섯째아이',
    '서른여섯째아이',
    '서른일곱째아이',
    '서른여덟째아이',
    '서른아홉째아이',
    '마흔째아이',
    '마흔하나째아이',
    '마흔둘째아이',
    '마흔셋째아이',
    '마흔넷째아이',
    '마흔다섯째아이',
    '마흔여섯째아이',
    '마흔일곱째아이',
    '마흔여덟째아이',
    '마흔아홉째아이',
    '쉰째아이',
];